import { takeLatest, call, put, all } from 'redux-saga/effects';
import { searchInformation } from '../_services/search.services';
import { fetchSearchBuyableFunds } from '../_services/order-request.services';
import { 
  searchSuccess, 
  searchFailure,
  subNavSearchSuccess,
  subNavSearchFailure,
  searchFundCalendarSuccess,
  searchFundCalendarFailure
} from '../_actions/search.actions';
import { searchConstants } from '../_constants/search.constants';

export function* searchStartAsync({ payload }) {
  try {
    const result = yield call(searchInformation, payload);
    yield put(searchSuccess(result.data));
  } catch (error) {
    yield put(searchFailure(error.message));
  }
}

export function* subNavSearchStartAsync({ payload }) {
  try {
    const result = yield call(searchInformation, payload);
    yield put(subNavSearchSuccess(result.data));
  } catch (error) {
    yield put(subNavSearchFailure(error.message));
  }
}

export function* searchFundCalendarStartAsync({ payload }) {
  let queryString = { keyword: payload };
  try {
    const result = yield call(fetchSearchBuyableFunds, queryString);
    yield put(searchFundCalendarSuccess(result.data));
  } catch (error) {
    yield put(searchFundCalendarFailure(error.message));
  }
}
export function* searchStart() {
  yield takeLatest(searchConstants.FETCH_MAIN_SEARCH_START, searchStartAsync);
}

export function* subNavSearchStart() {
  yield takeLatest(searchConstants.FETCH_SUBNAV_SEARCH_START, subNavSearchStartAsync);
}

export function* searchFundCalendarStart() {
  yield takeLatest(searchConstants.FETCH_SEARCH_FUND_CALENDAR_START, searchFundCalendarStartAsync);
}

export function* searchSagas() {
  yield all([call(searchStart), call(subNavSearchStart), call(searchFundCalendarStart)]);
}
